const BYTES_PER_KIB = 1024
const BYTES_PER_MIB = BYTES_PER_KIB * BYTES_PER_KIB

export function formatBytes(bytes: number): string {
  if (bytes < BYTES_PER_KIB) return `${String(bytes)} B`
  if (bytes < BYTES_PER_MIB) return `${(bytes / BYTES_PER_KIB).toFixed(1)} KB`
  return `${(bytes / BYTES_PER_MIB).toFixed(1)} MB`
}
